import { render } from "./RecalForm.vue?vue&type=template&id=5fe5639a"
import script from "./RecalForm.vue?vue&type=script&lang=js"
export * from "./RecalForm.vue?vue&type=script&lang=js"

import "./RecalForm.vue?vue&type=style&index=0&id=5fe5639a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__